<script lang="ts">
	import { createEventDispatcher } from 'svelte';

	const dispatch = createEventDispatcher<{ change: { checked: boolean } }>();

	export let checked = false;
	export let disabled = false;
	export let id: string | null = null;
	export let color: string = '#292929';

	function onChange(e: Event) {
		const target = e.target as HTMLInputElement;
		checked = target.checked;
		dispatch('change', { checked: target.checked });
	}
</script>

<label class="custom-checkbox">
	<input {id} {disabled} type="checkbox" bind:checked on:change={onChange} />
	<span class="checkmark" style="--checkbox-color: {color}" />
</label>

<style>
	.custom-checkbox {
		padding-left: 20px;
		cursor: pointer;
		font-size: 22px;
		user-select: none;
		position: relative;
	}

	.custom-checkbox input {
		position: absolute;
		opacity: 0;
		cursor: pointer;
		height: 0;
		width: 0;
	}

	.checkmark {
		position: absolute;
		top: 0;
		left: 0;
		height: 20px;
		width: 20px;
		background-color: #fff;
		border-radius: 4px;
		border: 1px solid var(--checkbox-color);
	}

	.custom-checkbox input:checked ~ .checkmark {
		background-color: #fff;
	}

	.checkmark:after {
		content: '';
		position: absolute;
		display: none;
	}

	.custom-checkbox input:checked ~ .checkmark:after {
		display: block;
	}

	.custom-checkbox .checkmark:after {
		left: 8px;
		top: 3px;
		width: 4px;
		height: 10px;
		border: solid var(--checkbox-color);
		border-width: 0 2px 2px 0;
		transform: rotate(45deg);
	}
	.custom-checkbox input:disabled ~ .checkmark {
		opacity: 0.5;
		cursor: auto;
	}
</style>
